import React, { useEffect, useRef } from "react";
import AboutCompany from "../components/Homecomponent/AboutCompany";
import Bynft from "../components/Homecomponent/Bynft";
import OurProjects from "../components/Homecomponent/OurProjects";
import OurServices from "../components/Homecomponent/OurServices";
import CustomManaging from "../components/Homecomponent/Custom&&Managing";
import SecondProject from "../components/Homecomponent/SecondProject";
import Specification from "../components/Homecomponent/Specification";
import "../Styles/homeComponents.css";

export default function Home() {
  const specificationRef = useRef(null);

  useEffect(() => {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animation-started");
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5, // Adjust threshold as needed
    });

    observer.observe(specificationRef.current);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}>
      <Bynft />
      <div id="about">
        <AboutCompany />
      </div>

      <div id="our_projects">
        <OurProjects />
      </div>
      <SecondProject />

      <div id="our-services">
        <OurServices />
      </div>

      <CustomManaging />
      <div ref={specificationRef}>
        <Specification />
      </div>
    </div>
  );
}
